import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { allowedCommissionTypes } from 'pages/finance/commission/commission/CommissionEnums';
import AgreementCommissionStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/AgreementCommissionStageSteps';
import { TaskModalPageProps } from '../TaskModalPageProps';
import { resolveQldAgreementComplianceTaskLayout } from '../agreementComplianceTaskLayout';

const QldAgreementCommissionPage = ({
  tasks,
  toggleTaskStepForTask,
  commissionDetails,
  currentCommissionInfo,
  onCommissionUpdated,
  registerTaskModalPageValidation,
}: TaskModalPageProps) => {
  const { commissionStep } = resolveQldAgreementComplianceTaskLayout(tasks);

  if (!onCommissionUpdated) {
    return null;
  }

  const updateCommissionTaskStep = (isCompleted: boolean) => {
    toggleTaskStepForTask(commissionStep.task.id, commissionStep.step.order ?? 0, isCompleted);
  };

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step3title" color="var(--text-primary)">
        Step 3 : Commission
      </AgxTypography>
      <AgreementCommissionStageSteps
        commissionDetails={commissionDetails}
        onCommissionUpdated={onCommissionUpdated}
        allowedCommissionTypes={allowedCommissionTypes}
        currentCommissionInfo={currentCommissionInfo}
        commissionStep={commissionStep.step}
        updateCommissionTaskStep={updateCommissionTaskStep}
        registerTaskModalPageValidation={registerTaskModalPageValidation}
      />
    </AgxSpacer>
  );
};

export default QldAgreementCommissionPage;
